/**
 * Created by Qianhao Luo on 2020/02/19
 */
module.exports = require('./lib/MaskClass');
exports.default = require('./lib/MaskClass');